import React from "react";

type Props = {
  id: string;
  selectProps?: any;
};
const SelectSvgSelector = ({ id, selectProps }: Props) => {
  switch (id) {
    case "orderSelectArrow":
      return (
        <svg
          style={{
            transform: selectProps.menuIsOpen ? "rotate(180deg)" : "",
            transition: "400ms",
          }}
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          <rect x="0.818359" width="14" height="14" fill="url(#pattern0)" />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_1_2936" transform="scale(0.0078125)" />
            </pattern>
            <image
              id="image0_1_2936"
              width="128"
              height="128"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      );
    case "nameIcon":
      return (
        <svg
          width="16"
          height="15"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.7554 11.1855C12.4791 10.531 12.0781 9.93648 11.5747 9.43506C11.0729 8.93219 10.4785 8.53126 9.82426 8.25439C9.8184 8.25146 9.81254 8.25 9.80668 8.24707C10.7193 7.58789 11.3125 6.51416 11.3125 5.30273C11.3125 3.2959 9.68656 1.66992 7.67972 1.66992C5.67289 1.66992 4.04691 3.2959 4.04691 5.30273C4.04691 6.51416 4.64017 7.58789 5.55277 8.24853C5.54691 8.25146 5.54105 8.25293 5.53519 8.25586C4.87894 8.53271 4.29008 8.92969 3.7847 9.43652C3.28184 9.93833 2.8809 10.5328 2.60404 11.187C2.33205 11.8275 2.18536 12.5142 2.17191 13.21C2.17152 13.2256 2.17426 13.2411 2.17998 13.2557C2.18569 13.2703 2.19426 13.2835 2.20518 13.2947C2.2161 13.3059 2.22915 13.3148 2.24357 13.3209C2.25798 13.327 2.27346 13.3301 2.2891 13.3301H3.16801C3.23246 13.3301 3.28373 13.2788 3.28519 13.2158C3.31449 12.085 3.76859 11.0259 4.57133 10.2231C5.40189 9.39258 6.50492 8.93555 7.67972 8.93555C8.85453 8.93555 9.95756 9.39258 10.7881 10.2231C11.5909 11.0259 12.045 12.085 12.0743 13.2158C12.0757 13.2803 12.127 13.3301 12.1914 13.3301H13.0704C13.086 13.3301 13.1015 13.327 13.1159 13.3209C13.1303 13.3148 13.1433 13.3059 13.1543 13.2947C13.1652 13.2835 13.1738 13.2703 13.1795 13.2557C13.1852 13.2411 13.1879 13.2256 13.1875 13.21C13.1729 12.5098 13.0279 11.8286 12.7554 11.1855ZM7.67972 7.82227C7.00736 7.82227 6.37455 7.56006 5.89847 7.08398C5.4224 6.60791 5.16019 5.9751 5.16019 5.30273C5.16019 4.63037 5.4224 3.99756 5.89847 3.52148C6.37455 3.04541 7.00736 2.7832 7.67972 2.7832C8.35209 2.7832 8.9849 3.04541 9.46097 3.52148C9.93705 3.99756 10.1993 4.63037 10.1993 5.30273C10.1993 5.9751 9.93705 6.60791 9.46097 7.08398C8.9849 7.56006 8.35209 7.82227 7.67972 7.82227Z"
            fill="#4D4D4D"
          />
        </svg>
      );
    case "phone":
      return (
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_2981)">
            <path
              d="M6.3416 8.60001C7.21139 9.48237 8.26381 10.1636 9.42494 10.5958L10.9958 9.34585C11.0423 9.31378 11.0976 9.2966 11.1541 9.2966C11.2107 9.2966 11.2659 9.31378 11.3124 9.34585L14.2291 11.225C14.3398 11.2916 14.4336 11.383 14.5029 11.492C14.5722 11.601 14.6153 11.7247 14.6286 11.8532C14.6419 11.9817 14.6252 12.1116 14.5797 12.2325C14.5343 12.3534 14.4613 12.4621 14.3666 12.55L12.9999 13.9C12.8042 14.0934 12.5637 14.2353 12.2997 14.3131C12.0358 14.3909 11.7568 14.4022 11.4874 14.3458C8.80086 13.791 6.32458 12.4915 4.3416 10.5958C2.40264 8.68137 1.06088 6.24537 0.479103 3.58335C0.421631 3.3182 0.433626 3.0427 0.513927 2.78354C0.594227 2.52439 0.74011 2.29038 0.937437 2.10418L2.3541 0.737513C2.44177 0.647425 2.54868 0.578336 2.66683 0.535421C2.78498 0.492505 2.91131 0.476875 3.03636 0.4897C3.16141 0.502526 3.28193 0.543474 3.38891 0.60948C3.49589 0.675486 3.58655 0.764838 3.6541 0.870847L5.59577 3.75001C5.62926 3.79522 5.64734 3.85 5.64734 3.90626C5.64734 3.96253 5.62926 4.0173 5.59577 4.06251L4.3166 5.60001C4.7606 6.73791 5.45233 7.76269 6.3416 8.60001Z"
              fill="#4D4D4D"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_2981">
              <rect width="15" height="15" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case "calendar":
      return (
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1_3651)">
            <path
              d="M5.2699 9.59577V5.38472H4.77016C4.41225 5.57551 4.06634 5.78801 3.73438 6.02103V6.56972C4.03043 6.36682 4.49937 6.08024 4.72753 5.9563H4.73701V9.59577H5.2699ZM6.2078 8.56551C6.2449 9.07077 6.67674 9.67551 7.55227 9.67551C8.54543 9.67551 9.13122 8.83393 9.13122 7.40893C9.13122 5.88209 8.51464 5.30261 7.58938 5.30261C6.85832 5.30261 6.17069 5.83314 6.17069 6.73077C6.17069 7.64656 6.82122 8.12814 7.49385 8.12814C8.0828 8.12814 8.4649 7.8313 8.58569 7.50445H8.60701C8.60385 8.5434 8.24306 9.21288 7.57674 9.21288C7.05253 9.21288 6.78095 8.85761 6.7478 8.56551H6.2078ZM8.53911 6.7363C8.53911 7.28577 8.0978 7.66788 7.60438 7.66788C7.1299 7.66788 6.70122 7.36551 6.70122 6.72051C6.70122 6.07077 7.16069 5.76524 7.62332 5.76524C8.12306 5.76524 8.53911 6.07945 8.53911 6.7363Z"
              fill="#4D4D4D"
            />
            <path
              d="M2.9448 0.368408C3.04949 0.368408 3.14989 0.409996 3.22392 0.484024C3.29795 0.558051 3.33954 0.658454 3.33954 0.763145V1.15788H9.65532V0.763145C9.65532 0.658454 9.69691 0.558051 9.77094 0.484024C9.84497 0.409996 9.94537 0.368408 10.0501 0.368408C10.1548 0.368408 10.2552 0.409996 10.3292 0.484024C10.4032 0.558051 10.4448 0.658454 10.4448 0.763145V1.15788H11.2343C11.653 1.15788 12.0546 1.32423 12.3508 1.62034C12.6469 1.91645 12.8132 2.31807 12.8132 2.73683V11.421C12.8132 11.8398 12.6469 12.2414 12.3508 12.5375C12.0546 12.8336 11.653 13 11.2343 13H1.76059C1.34183 13 0.940214 12.8336 0.644104 12.5375C0.347994 12.2414 0.181641 11.8398 0.181641 11.421V2.73683C0.181641 2.31807 0.347994 1.91645 0.644104 1.62034C0.940214 1.32423 1.34183 1.15788 1.76059 1.15788H2.55006V0.763145C2.55006 0.658454 2.59165 0.558051 2.66568 0.484024C2.73971 0.409996 2.84011 0.368408 2.9448 0.368408V0.368408ZM0.971114 3.5263V11.421C0.971114 11.6304 1.05429 11.8312 1.20235 11.9793C1.3504 12.1273 1.55121 12.2105 1.76059 12.2105H11.2343C11.4437 12.2105 11.6445 12.1273 11.7925 11.9793C11.9406 11.8312 12.0237 11.6304 12.0237 11.421V3.5263H0.971114Z"
              fill="#4D4D4D"
            />
          </g>
          <defs>
            <clipPath id="clip0_1_3651">
              <rect
                width="12.6316"
                height="12.6316"
                fill="white"
                transform="translate(0.181641 0.368408)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "email":
      return (
        <svg
          width="16"
          height="15"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.9316 3.75C13.9316 3.0625 13.3691 2.5 12.6816 2.5H2.68164C1.99414 2.5 1.43164 3.0625 1.43164 3.75V11.25C1.43164 11.9375 1.99414 12.5 2.68164 12.5H12.6816C13.3691 12.5 13.9316 11.9375 13.9316 11.25V3.75ZM12.6816 3.75L7.68164 6.875L2.68164 3.75H12.6816ZM12.6816 11.25H2.68164V5L7.68164 8.125L12.6816 5V11.25Z"
            fill="#4D4D4D"
          />
        </svg>
      );
    case "password":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.50016 12.8334C3.17933 12.8334 2.90477 12.7192 2.6765 12.491C2.44783 12.2623 2.3335 11.9875 2.3335 11.6667V5.83337C2.3335 5.51254 2.44783 5.23779 2.6765 5.00912C2.90477 4.78085 3.17933 4.66671 3.50016 4.66671H8.75016V3.50004C8.75016 3.01393 8.58002 2.60073 8.23975 2.26046C7.89947 1.92018 7.48627 1.75004 7.00016 1.75004C6.60155 1.75004 6.24922 1.86904 5.94316 2.10704C5.63672 2.34543 5.43002 2.64448 5.32308 3.00421C5.27447 3.15004 5.19922 3.26904 5.09733 3.36121C4.99505 3.45376 4.87586 3.50004 4.73975 3.50004C4.5453 3.50004 4.38975 3.43432 4.27308 3.30287C4.15641 3.17182 4.11752 3.02365 4.15641 2.85837C4.30225 2.20699 4.63766 1.66487 5.16266 1.23204C5.68766 0.799596 6.30016 0.583374 7.00016 0.583374C7.80711 0.583374 8.49505 0.867652 9.064 1.43621C9.63255 2.00515 9.91683 2.6931 9.91683 3.50004V4.66671H10.5002C10.821 4.66671 11.0957 4.78085 11.3244 5.00912C11.5527 5.23779 11.6668 5.51254 11.6668 5.83337V11.6667C11.6668 11.9875 11.5527 12.2623 11.3244 12.491C11.0957 12.7192 10.821 12.8334 10.5002 12.8334H3.50016ZM3.50016 11.6667H10.5002V5.83337H3.50016V11.6667ZM7.00016 9.91671C7.321 9.91671 7.59575 9.80257 7.82441 9.57429C8.05269 9.34562 8.16683 9.07087 8.16683 8.75004C8.16683 8.42921 8.05269 8.15446 7.82441 7.92579C7.59575 7.69751 7.321 7.58337 7.00016 7.58337C6.67933 7.58337 6.40477 7.69751 6.1765 7.92579C5.94783 8.15446 5.8335 8.42921 5.8335 8.75004C5.8335 9.07087 5.94783 9.34562 6.1765 9.57429C6.40477 9.80257 6.67933 9.91671 7.00016 9.91671ZM3.50016 5.83337V11.6667V5.83337Z"
            fill="#4D4D4D"
          />
        </svg>
      );
    case "eye":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 4C5 4 1.73 7.11 1 10c.73 2.89 4 6 9 6s8.27-3.11 9-6c-.73-2.89-4-6-9-6zm0 10a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
            fill="#4D4D4D"
          />
        </svg>
      );
    case "eyeOff":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 4c5 0 8.27 3.11 9 6-.18.71-.63 1.65-1.38 2.65l-1.4-1.4c.42-.59.72-1.12.85-1.51-.73-1.88-3.17-4.24-7.07-4.24-1.17 0-2.26.24-3.24.65l-1.46-1.46C6.47 4.25 8.17 4 10 4zM1.71 2.71l1.44 1.44C2.39 5.13 1.73 6.11 1 10c.73 2.89 4 6 9 6 1.52 0 2.94-.32 4.21-.87l1.08 1.08 1.42-1.42L3.13 1.29l-1.42 1.42zM7.53 9.11l1.36 1.36a2.5 2.5 0 0 0 3.1 3.1l1.36 1.36A4 4 0 0 1 7.53 9.11zm2.97-.61l2.61 2.61a2.5 2.5 0 0 0-2.61-2.61z"
            fill="#4D4D4D"
          />
        </svg>
      );

    default:
      return <svg></svg>;
  }
};

export default SelectSvgSelector;
